/* eslint-disable no-unexpected-multiline */
import styled from 'styled-components';
import * as T from './PlaylistItem.types';

export const PlaylistItem = styled.button`
  position: relative;
  display: flex;
  flex: 0 0 32px;
  background-color: transparent;
  text-align: left;
  font-size: 14px;
  font-weight: 300;
  width: 100%;
  transition: background-color 0.2s ease;
  color: ${({ theme }) => theme.textColor};
  align-items: center;
  margin: 0;
  border: none;

  :hover {
    cursor: pointer;
    background-color: ${({ theme }) => theme.currentlyPlayingTrackBackgroundColor};
  }

  &.isCurrentlyPlaying {
    color: ${({ theme }) => theme.currentlyPlayingTrackColor};
    background-color: ${({ theme }) => theme.currentlyPlayingTrackBackgroundColor};
  }

  strong {
    font-weight: 500;
  }
`;

export const PlaylistItemWrapper = styled.div`
  display: flex;
  padding: 0 12px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

export const PlaylistItemPosition = styled.strong<T.IPlaylistItemPositionProps>`
  display: flex;
  justify-content: center;
  min-width: ${({ playlistPosition }) => (playlistPosition < 10 ? 17 : 22)}px;
`;

export const PlaylistItemSpinnerWrapper = styled.div<T.IPlaylistItemSpinnerWrapperProps>`
  min-width: ${({ playlistPosition }) => (playlistPosition < 10 ? 17 : 22)}px;
`;

export const PlaylistItemText = styled.div<T.IPlaylistItemTextProps>`
  padding-left: 12px;
  width: calc(100% - ${({ playlistPosition }) => (playlistPosition < 10 ? 17 : 22)}px);
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

export const PlayOverviewTooltip = styled.div`
  position: absolute;
  left: 48px;
  top: 8px;
  width: calc(100% - 84px);
  padding: 12px;
  box-shadow: 1px 12px 35px -6px ${({ theme }) => theme.tooltipShadowColor};
  // Intentionally background
  background: ${(props) => props.theme.tooltipBackground};
  border-radius: 6px;
  z-index: 100;
`;
